module.exports = "<app-route-edit-template on-cancel=$ctrl.cancel() on-save=$ctrl.save() route=$ctrl.route switch-tab-prefix=app.route.update> </app-route-edit-template> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/update/partial.html
// module id = 495
// module chunks = 0